import { createAction, props } from '@ngrx/store';
import { IAccountData, IAccountModel } from '@partners/api';

export class AccountActions {
  static reset = createAction('[Account] Reset State');
  static load = createAction('[Account] Load');
  static loadSuccess = createAction('[Account] Load Success', props<{ model: IAccountModel; data: IAccountData }>());
  static loadFailure = createAction('[Account] Load Failure', props<{ error: any }>());
  static submit = createAction('[Account] Submit', props<{ model: IAccountModel }>());
  static submitSuccess = createAction('[Account] Submit Success', props<{ data: IAccountData }>());
  static submitFailure = createAction('[Account] Submit Failure', props<{ error: any }>());
}
